import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'
import { singleSelectClasses } from '../componentClassNames'

export const inputWrapper = css({
  position: 'relative',
  // The design's gap between a label and its select.
  [`.${singleSelectClasses.label} + .${singleSelectClasses.trigger}`]: {
    marginTop: Spacing.S,
  },
})
